/* Uit Krabbelpaal.dc.html; bodies letterlijk overgenomen. */

import { GH, GW, PB_URL } from '../lib/config.js';
import * as store from '../lib/store.js';

export default {
  snapshotCanvas() {
      if (this.opBefore) this.commitOp();
      if (this.state.duo) this.duoQueueSend();
      /**
       * Alleen de vraag of het doek er staat, en niet welk scherm voor je ligt.
       *
       * Dit stond op `view === 'studio' && canvasRef`, en dat betekende in de praktijk
       * hetzelfde tot het tekenvenster weggeklapt kon worden. Toen niet meer: dan
       * bewaarde dit stil niets en was je werk sinds de laatste opslag weg, zonder
       * foutmelding. Staat het doek in de pagina, dan zijn zijn pixels de waarheid.
       */
      if (this.canvasRef.current) {
        this.savedImage = this.getCtx().getImageData(0, 0, GW, GH);
        this.persistWip();
      }
    },

  persistWip() {
      if (this.state.duo) return;
      clearTimeout(this.wipTimer);
      this.wipTimer = setTimeout(() => {
        const cv = this.canvasRef.current;
        if (!cv) return;
        try {
          const url = this.frameNow();
          const idx = this.state.frameIdx || 0;
          const frames = this.framesArr();
          frames[idx] = url;
          this.wipTouched = true;
          if (idx === 0) {
            if (url) store.set('gp_wip', url); else store.remove('gp_wip');
            // Tijdstempel erbij, zodat we bij het openen kunnen zien welke versie
            // de nieuwste is: die in deze browser of die op de server.
            try { store.set('gp_wip_at', String(Date.now())); } catch (err) {}
            this.wipDirty = url;
            // Het plekje in de projectmap loopt mee met wat er op de paal staat.
            const slot = this.state.slot || 0;
            store.set(this.slotKey(slot), url);
            if (((this.state.slotArt || [])[slot] || '') !== url) {
              const art = [...(this.state.slotArt || ['', ''])];
              art[slot] = url;
              this.setState({ slotArt: art });
            }
            // En naar de server, zodat een gesloten tabblad je krabbel niet opeet.
            clearTimeout(this.wipCloudTimer);
            this.wipCloudTimer = setTimeout(() => {
              if (this.wipDirty === url) this.wipDirty = null;
              this.saveProject(slot, url);
            }, 1200);
          } else {
            // Beeld 2 en verder reizen samen naar plek 2.
            this.stashExtra(frames, this.onArr());
          }
          if ((this.framesArr()[idx] || '') !== url) this.setState({ frames });
        } catch (err) {}
      }, 400);
    },

  // Alles wat nog in de wachtrij staat meteen naar de server duwen. Wordt ook
  // aangeroepen als het tabblad naar de achtergrond gaat of wordt gesloten.
  flushWip() {
      if (this.state.duo) return;
      clearTimeout(this.wipCloudTimer);
      const me = this.state.accountId;
      if (!me || !PB_URL || this.wipDirty == null) return;
      const art = this.wipDirty;
      this.wipDirty = null;
      const slot = this.state.slot || 0;
      const id = this.projRecs ? this.projRecs[slot] : null;
      // Zonder bekend record en met een verzoek onderweg: laten lopen, anders
      // maakt deze tweede POST een dubbele regel voor dezelfde plek.
      if (!id && this.projSaving && this.projSaving[slot]) return;
      const body = JSON.stringify({ accountId: me, slot, art: art || '' });
      const opts = { method: id ? 'PATCH' : 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true };
      const url = id
        ? `${PB_URL}/api/collections/paal_projects/records/${id}`
        : `${PB_URL}/api/collections/paal_projects/records`;
      try { fetch(url, opts).catch(() => {}); } catch (err) {}
    },

  restoreWip() {
      if (this.state.duo) return;
      let wip = null, extraRaw = null;
      try {
        wip = store.get('gp_wip');
        extraRaw = store.get('gp_wip_b');
      } catch (err) {}
      // Het werk van de vorige keer blijft bewaard, maar je begint met één beeld.
      const ex = this.parseExtra(extraRaw);
      this.setState({ frames: [wip || ''].concat(ex.art), frameOn: this.emptyOn(), frameIdx: 0 });
      if (!wip) return;
      const img = new Image();
      img.onload = () => {
        const c = document.createElement('canvas');
        c.width = GW; c.height = GH;
        const cx = c.getContext('2d');
        cx.imageSmoothingEnabled = false;
        cx.drawImage(img, 0, 0, GW, GH);
        this.savedImage = cx.getImageData(0, 0, GW, GH);
        if (this.canvasRef.current) {
          const ctx = this.getCtx();
          ctx.imageSmoothingEnabled = false;
          ctx.putImageData(this.savedImage, 0, 0);
        } else {
          this.needsRestore = true;
        }
      };
      img.src = wip;
    }
};
